module.exports = __webpack_public_path__ + "static/media/layers.39e09a06.svg";